import { render, staticRenderFns } from "./dashBoard.vue?vue&type=template&id=e78fced6&scoped=true"
import script from "./dashBoard.vue?vue&type=script&lang=js"
export * from "./dashBoard.vue?vue&type=script&lang=js"
import style0 from "./dashBoard.vue?vue&type=style&index=0&id=e78fced6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e78fced6",
  null
  
)

export default component.exports